module.exports = __webpack_public_path__ + "img/西瓜8.aa446850.png";